import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Lock, Eye, EyeOff, Phone } from 'lucide-react';
import Header from './components/Header11';
import Footer from './components/Footer11';

const Signup11 = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ fullName: '', email: '', phone: '', password: '', confirmPassword: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/template11/login');
    };

    const inputStyle = {
        width: '100%', padding: '14px 16px 14px 44px', backgroundColor: '#292524', border: '1px solid #44403C', color: '#FAFAF9',
        fontFamily: "'Source Sans 3', sans-serif", fontSize: '14px', outline: 'none', transition: 'border-color 0.3s ease',
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
                .veer-signup-input:focus { border-color: #D97706 !important; }
                .veer-signup-input::placeholder { color: #78716C; }
            `}</style>

            <div style={{ fontFamily: "'Source Sans 3', -apple-system, sans-serif" }} className="min-h-screen bg-[#1C1917]">
                <Header />

                <main className="pt-20 min-h-screen flex">
                    {/* Left Side - Image (Desktop) */}
                    <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
                        <img src="https://images.pexels.com/photos/3363204/pexels-photo-3363204.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="Men's fashion" className="absolute inset-0 w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-r from-[#1C1917]/40 via-[#1C1917]/60 to-[#1C1917]" />
                        <div className="relative z-10 flex flex-col justify-center items-start p-16 max-w-lg">
                            <div className="w-12 h-0.5 mb-6" style={{ backgroundColor: '#D97706' }} />
                            <h2 className="text-4xl xl:text-5xl font-bold mb-4" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>
                                JOIN THE BROTHERHOOD
                            </h2>
                            <p className="text-base" style={{ color: '#A8A29E' }}>
                                Create your account and unlock exclusive access.
                            </p>
                        </div>
                    </div>

                    {/* Right Side - Form */}
                    <div className="w-full lg:w-1/2 flex items-center justify-center px-6 py-12">
                        <div className="w-full max-w-md">
                            <div className="w-10 h-0.5 mb-4" style={{ backgroundColor: '#D97706' }} />
                            <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>CREATE ACCOUNT</h1>
                            <p className="text-sm mb-8" style={{ color: '#A8A29E' }}>Fill in the details below to get started</p>

                            <form onSubmit={handleSubmit} className="space-y-4">
                                <div className="relative">
                                    <User size={18} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#A8A29E' }} />
                                    <input name="fullName" value={formData.fullName} onChange={handleInputChange} placeholder="Full Name" style={inputStyle} className="veer-signup-input" />
                                </div>
                                <div className="relative">
                                    <Mail size={18} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#A8A29E' }} />
                                    <input name="email" type="email" value={formData.email} onChange={handleInputChange} placeholder="Email Address" style={inputStyle} className="veer-signup-input" />
                                </div>
                                <div className="relative">
                                    <Phone size={18} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#A8A29E' }} />
                                    <input name="phone" value={formData.phone} onChange={handleInputChange} placeholder="Phone Number" style={inputStyle} className="veer-signup-input" />
                                </div>
                                <div className="relative">
                                    <Lock size={18} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#A8A29E' }} />
                                    <input name="password" type={showPassword ? 'text' : 'password'} value={formData.password} onChange={handleInputChange} placeholder="Password" style={inputStyle} className="veer-signup-input" />
                                    <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#A8A29E', cursor: 'pointer' }}>
                                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </button>
                                </div>
                                <div className="relative">
                                    <Lock size={18} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#A8A29E' }} />
                                    <input name="confirmPassword" type="password" value={formData.confirmPassword} onChange={handleInputChange} placeholder="Confirm Password" style={inputStyle} className="veer-signup-input" />
                                </div>
                                <button type="submit" className="w-full py-4 text-sm tracking-[0.15em] uppercase transition-colors duration-300" style={{ backgroundColor: '#D97706', border: 'none', color: '#1C1917', fontFamily: "'Oswald', sans-serif", fontWeight: 600, cursor: 'pointer' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F59E0B')}
                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#D97706')}
                                >
                                    Create Account
                                </button>
                            </form>

                            <p className="text-sm text-center mt-8" style={{ color: '#A8A29E' }}>
                                Already have an account?{' '}
                                <button onClick={() => navigate('/template11/login')} style={{ color: '#D97706', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>Sign In</button>
                            </p>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Signup11;
